import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {map, switchMap, takeUntil, tap} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, ReplaySubject} from 'rxjs';
import {TorchUser} from '@backend/modules/@users/models/torch-user.model';
import {TorchUserService} from '@backend/modules/@users/services/torch-user.service';

@Component({
  selector: 'app-manage-user-roles',
  templateUrl: './manage-user-roles.component.html',
  styleUrls: ['./manage-user-roles.component.scss']
})
export class ManageUserRolesComponent implements OnInit, OnDestroy {

  hasLoaded = new BehaviorSubject<boolean>(false);
  sessionUser: TorchUser;
  currentUser: TorchUser;

  allUserRoles: string[] = [];
  currentUserRoles: string[] = [];
  disabledRoles: string[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private torchUserService: TorchUserService) {
    this.hasLoaded.next(false);
    this.torchUserService.currentTorchUser.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(sessionUser => this.sessionUser = sessionUser);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  @Input()
  set user(newValue: TorchUser | null) {
    this.hasLoaded.next(false);

    if (!!newValue) {
      this.currentUser = newValue;
      this.torchUserService.getRoles().pipe(
        takeUntil(this.destroyed$)
      ).subscribe( roles => {
        this.allUserRoles =  this.filterRoles(roles, this.currentUser.roles);
        this.currentUserRoles = this.currentUser.roles;
        this.hasLoaded.next(true);
      });
    }
  }

  handleRoleListChange(rawRoles: string[], username: string) {
    combineLatest([
        this.torchUserService.updatePermissions(rawRoles, username),
        this.torchUserService.getRoles()
      ]
    ).pipe(
      takeUntil(this.destroyed$),
      map(value => {
        const currentRoles = value[0].data.map(v => v.permission);
        return {currentRoles, allRoles: this.filterRoles(value[1], currentRoles)};
      })
    ).subscribe();
  }

  isDisabledRole(role: string): boolean {
    return this.disabledRoles.includes(role);
  }

  isEnabledRole(role: string): boolean {
    return this.currentUserRoles.includes(role);
  }

  get isSessionUser(): boolean {
    if (!!this.sessionUser) {
      return this.sessionUser.emailAddress === this.currentUser.emailAddress;
    }

    return false;
  }

  private filterRoles(roles: string[], currentRoles: string[]): string[] {
    if (this.isSessionUser) {
      // this.disabledRoles = roles.filter(role => currentRoles.includes(role));
      // keaton if you see this, you literally let every user assign any permission
      // to themselves if they didnt already have it assigned lmao
      this.disabledRoles = roles;
    } else {
      this.disabledRoles = [];
    }

    return roles;
  }
}
